<template>
    <div  :class="baseerp+'div'" >
        <div class="flex"style="margin:5px 14px" >
            <el-input style=" width:200px;" v-model="search" clearable placeholder="搜索" size="mini">
            </el-input>
            <el-button  plain  style="margin-left: 5px"  size="mini" @click="searchFun" >{{$t('button_search_for')}}</el-button>
            <el-button  type="primary" :class="baseerp+'btn'" size="mini" @click="add">新增</el-button>
        </div>

        <el-table
                class="mrt10"
                ref="table"
                size="mini"
                :height="tableHeight"
                border
                :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%;margin-right: 9px;margin-left: 9px">
            <el-table-column  :label="$t('form_serial_number')" align="center" type="index" width="50px"></el-table-column>
            <el-table-column align="center"  label="模板名称" prop="vc_keyname" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="关联业务表名" prop="vc_table"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="录入人" prop="vc_creator"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="录入日期" prop="dt_createtime"   show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" prop="f_txlv1"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="detail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        @size-change="sizeChange"
                        :page-sizes="[20,50,100]"
                        layout="total,sizes,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <el-dialog
                class="cldialog"
                style="display: flex;justify-content: center;align-items: center;"
                width="70%"
                top="30"
                height="300"
                :title="detailTitle"
                :visible.sync="detailDialog"
                v-if="detailDialog"
                :close-on-click-modal="false" @close="detailClose">
            <detail-page :data="detailData" @close="detailClose"></detail-page>
        </el-dialog>


    </div>
</template>

<script>
    import * as API from "./api"
    import DetailPage from "./DetailPage";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "index",
        components: {DetailPage},
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                detailData:{},
                detailDialog:false,
                detailTitle:'新增',
                search:'',
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp
            this.getExcelTempList()

            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

            },
            add(){
                this.detailData={
                    i_id:0,
                }

                this.detailDialog=true
            },
            detail(item){
                this.detailData=item;
                this.detailDialog=true
            },
            detailClose(type='back',data=[]){
                if (type=='back'){

                }else{
                    this.getExcelTempList()
                }
                this.detailDialog=false
            },
            searchFun(){
                this.currentPage=1;
                this.getExcelTempList();
            },
            async getExcelTempList(){
                let param={
                    vc_keyname:this.search,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                };
                let res=await API.getExcelTempList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getExcelTempList();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getExcelTempList();
            },

        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        /*align-items: center;*/
    }
    .w100{
        width: 100%;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 700px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }

    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .dib{
        display: inline-block;
    }
    .ckys{
        width: 340px;
        display: inline-block;
        margin: 0 4px;
        border: 1px solid #DCDFE6;
    }
    .wi{
        width:inherit;
    }
    .w100-480{
        width: calc(100% - 350px);
    }
    .p-5-9{
        padding: 5px 9px;
    }
    .jcsb{
        justify-content: space-between;
    }

</style>